var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 65,
    viewBox: "0 0 48 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4047_966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.25 47.41H4.15C2.41 47.41 1 46 1 44.26V4.15C1 2.41 2.41 1 4.15 1H27.03L27.11 6.4C27.08 8.09 28.02 9.49 30.26 9.55L35.4 9.65V44.26C35.4 46 33.99 47.41 32.25 47.41Z",
    fill: "white",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45996 38.0703H21.56",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0303 1L35.4003 9.65",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45996 12.5996H28.94",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45996 21.0898H28.94",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45996 29.5801H28.94",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.72 40.9299C26.18 40.8199 25.53 39.9799 25.46 38.8599H26.77C26.83 39.3799 27.02 39.7899 27.72 39.8999V38.1899C26.31 37.9699 25.63 37.4499 25.63 36.2799C25.63 35.2599 26.45 34.4999 27.72 34.4199V33.6299H28.35V34.4299C29.56 34.5399 30.29 35.1399 30.39 36.2899H29.12C29.04 35.8299 28.82 35.5399 28.35 35.4599V37.0499C29.68 37.2499 30.5 37.6999 30.5 38.9299C30.5 39.9999 29.75 40.8499 28.35 40.9499V42.0599H27.72V40.9499V40.9299ZM27.72 36.9299V35.4299C27.2 35.4999 26.91 35.7899 26.91 36.1699C26.91 36.5799 27.06 36.7999 27.72 36.9299ZM28.35 38.2899V39.9099C28.87 39.8199 29.18 39.5099 29.18 39.0799C29.18 38.6499 29 38.4399 28.35 38.2999V38.2899Z",
    fill: "#1EC95B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2402 63.1004H15.1402C13.4002 63.1004 11.9902 61.6904 11.9902 59.9504V19.8404C11.9902 18.1004 13.4002 16.6904 15.1402 16.6904H38.0202L38.1002 22.0904C38.0702 23.7804 39.0102 25.1804 41.2502 25.2404L46.3902 25.3404V59.9504C46.3902 61.6904 44.9802 63.1004 43.2402 63.1004Z",
    fill: "white",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4404 53.7607H32.5404",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0205 16.6904L46.3905 25.3404",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4404 28.29H39.9304",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4404 36.7803H39.9304",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4404 45.2705H39.9304",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7102 56.6203C37.1702 56.5103 36.5202 55.6703 36.4502 54.5503H37.7602C37.8202 55.0703 38.0102 55.4803 38.7102 55.5903V53.8803C37.3002 53.6603 36.6202 53.1403 36.6202 51.9703C36.6202 50.9503 37.4402 50.1903 38.7102 50.1103V49.3203H39.3402V50.1203C40.5502 50.2303 41.2802 50.8303 41.3802 51.9803H40.1102C40.0302 51.5203 39.8102 51.2303 39.3402 51.1503V52.7403C40.6702 52.9403 41.4902 53.3903 41.4902 54.6203C41.4902 55.6903 40.7402 56.5403 39.3402 56.6403V57.7503H38.7102V56.6403V56.6203ZM38.7102 52.6203V51.1203C38.1902 51.1903 37.9002 51.4803 37.9002 51.8603C37.9002 52.2703 38.0502 52.4903 38.7102 52.6203ZM39.3402 53.9803V55.6003C39.8602 55.5103 40.1702 55.2003 40.1702 54.7703C40.1702 54.3403 39.9902 54.1303 39.3402 53.9903V53.9803Z",
    fill: "#1EC95B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4047_966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.39,
    height: 64.1,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.388447b4a4d9deaab2bc402675a4ea4e.svg";
export { ForwardRef as ReactComponent };